import { GroupRequest } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateGroup: (
  fetchContext: FetchContext,
  groupId: number,
  groupRequest: GroupRequest,
  accessToken?: string,
) => Promise<number> = async (fetchContext, groupId, groupRequest, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/admin/groups/${groupId}`,
  {
    method: 'PUT',
    body: JSON.stringify(groupRequest),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<number>(fetchContext.errorStore, response, 'update group'));
